// Register every Stimulus controller here. Add a new line per file.
import { application } from './application'

import BrowserNotificationsController from './browser_notifications_controller'
import FlashController from './flash_controller'
import ModalController from './modal_controller'
import ModalTriggerController from './modal_trigger_controller'
import NotificationsPermissionController from './notifications_permission_controller'
import SlackSettingsTestController from './slack_settings_test_controller'
import SlackWebhookTestController from './slack_webhook_test_controller'

application.register('browser-notifications', BrowserNotificationsController)
application.register('flash', FlashController)
application.register('modal', ModalController)
application.register('modal-trigger', ModalTriggerController)
application.register('notifications-permission', NotificationsPermissionController)
application.register('slack-settings-test', SlackSettingsTestController)
application.register('slack-webhook-test', SlackWebhookTestController)
